<template>
	<header ref="header">
		<div class="logo padder">
			<div class="small">
				<span> RS </span>
			</div>
			<div class="big">
				<span> RedstoneServer </span>
			</div>
		</div>

		<nav ref="navigation">
			<div class="topbar" ref="topbar">
				<router-link class="t_link link padder" :to="element.val" v-for="element in primary" :key="element.key">{{ element.key }}</router-link>
			</div>
			<div class="wrapper">
				<span class="t_link_d t_link link padder" ref="dropdownArrow">VV</span>
				<div class="dropdown">
					<router-link class="d_link link" :to="element.val" v-for="element in secondary" :key="element.key">{{ element.key }}</router-link>
				</div>
			</div>
		</nav>

		<div class="user padder">
			<div v-if="user">
				<div class="big">
					<span>Username: {{ user.username }} </span>
					<span class="link padder" @click="logout">Logout</span>
				</div>
				<div class="small">
					<span>Hi, {{ user.username }} </span>
					<span class="link padder" @click="logout">Logout</span>
				</div>
			</div>
			<router-link class="link padder" to="/login" v-else>Login</router-link>
		</div>
	</header>
</template>

<script>
	export default {
		data () {
			return {
				links: {
					primary: {
						'Startpage': '/',
						'Applications': '/applications',
						'Development Blog': '/devblog',
					},
					secondary: {
						'Impressum': '/impressum',
					},
				},
				intLinks: {
					primary: [],
					secondary: [],
				},
				primary: [],
				secondary: [],
			}
		},
		created() {
			//Convert the given links to arrays for later processing.
			this.intLinks.primary = this.convertToArray(this.links.primary)
			this.intLinks.secondary = this.convertToArray(this.links.secondary)
		},
		computed: {
			user() {
				return this.$store.state.user
			},
		},
		methods: {
			updateMenu() {
				//Empty to measure the whole available space.
				this.primary = []
				this.compressed = false

				this.$nextTick(() => {
					let menubar = this.$refs.topbar
					//Subtract safety pixels, scrollbars come a bit later after resize.
					let maxWidth = this.$refs.navigation.clientWidth - this.$refs.dropdownArrow.offsetWidth - 30

					//Add all preprocessed links to measure them in current env.
					this.primary = this.intLinks.primary

					this.$nextTick(() => {
						let sizes = []
						for(let el of menubar.childNodes) {
							sizes.push(el.offsetWidth)
						}

						this.primary = []
						this.secondary = []

						let linkSize = this.intLinks.primary.length
						let tmp = 0;
						for(let i = 0; i < linkSize; i++) {
							tmp += sizes[i] //Add the size of the current element

							if(maxWidth > tmp) {
								this.primary.push(this.intLinks.primary[i])
							} else {
								this.secondary.push(this.intLinks.primary[i])
							}
						}

						this.secondary = this.secondary.concat(this.intLinks.secondary)
					})
				})
			},
			convertToArray(obj) {
				let els = []
				for(let key in obj) {
					if(obj.hasOwnProperty(key)) {
						els.push({
							key: key,
							val: obj[key],
						})
					}
				}
				return els
			},
			logout() {
				this.core.logout()
			},
		},
		watch: {
			user: function() {
				this.updateMenu()
			}
		},
		mounted() {
			window.addEventListener('resize', this.updateMenu)
			//Initial menu sorting
			this.updateMenu()			
		},
		beforeDestroy() {
			//TBI never will be closed...!
			window.removeEventListener('resize', this.updateMenu)
		},
	}
</script>

<style scoped>
	/*
	Whole line:
	*/
	header {
		display: flex;

		white-space: nowrap;
		background-color: #222;

		font-size: 1.5em;
	}
	nav {
		flex-grow: 100;

		/* try permanent? */
		display: flex;
		justify-content: center;
		align-items: center;
	}

	/*
	Dropdown mechanic:
	*/
	.dropdown {
		position: absolute;
		display: none;

		background-color: #222;

		/* Padder fix */
		margin-top: 0.18em;
		
		right: 50%;
		transform: translateX(50%);
	}
	.wrapper:hover > .dropdown {
		display: block;
	}
	/* For safari in a proper way again... all other mobile browsers do this anyway */
	.wrapper:active > .dropdown {
		display: block;
	}
	.wrapper {
		position: relative;
		display: inline;
	}
	.topbar {
		display: inline;
	}

	/*
	Generic link properties:
	*/
	.link {
		padding: 0em 0.2em;

		color: #aaa;
		text-decoration: none;
	}
	.link:hover {
		color: #ddd;
		background-color: #333;
	}

	/*
	Specific link properties:
	*/
	.t_link {
		border-right: 1px solid #aaa;
	}
	.d_link {
		display: block;
		border-top: 1px solid #aaa;
	}
	.t_link_d {
		border-right: none;
	}

	/*
	Header compression:
	*/
	.small {
		display: none;
	}

	/*
	Padding top-bottom
	*/
	.padder {
		padding-top: 0.2em;
		padding-bottom: 0.2em;
	}

	/*
	Small width should print less things.
	TODO: Investigate better conditions.
	*/
	@media (max-width: 600px) {
		/* Switch to the small logo */
		.small {
			display: initial;
		}
		.big {
			display: none;
		}

		/* Center the dropdown menu */
		.wrapper {
			position: initial;
		}
	}
</style>